import { filter, ignoreElements, tap } from "rxjs/operators";
import { IdEventSoundCore } from "../../../utils/sound/IdEventSoundCore";
import { utilSound } from "../../../utils/sound/utilSound";
import { TypeActionBuildings } from "../../player-base/buildings/actionBuildings";
export var epicSoundsBuildingRotate = function (action$) {
    return action$.pipe(filter(function (action) { return action.type === TypeActionBuildings.Rotate; }), tap(function () { return utilSound.event(IdEventSoundCore.BuildingRotate); }), ignoreElements());
};



//////////////////
// WEBPACK FOOTER
// ./src/features/sound/epics/epicSoundsBuildingRotate.ts
// module id = 2404
// module chunks = 3